import { Link } from 'react-router-dom'
import { Users2 } from 'lucide-react'

export function NavBar() {
  return (
    <nav className="border-b border-border">
      <div className="mx-auto flex max-w-6xl items-center gap-6 px-6 py-3 text-sm">
        <Link to="/" className="font-medium hover:text-primary">
          Overview
        </Link>
        <Link
          to="/instructors"
          className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground"
        >
          <Users2 className="size-4" />
          All instructors
        </Link>
      </div>
    </nav>
  )
}
